import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';
import { StatusTile } from './StatusTile';
import { CommonStyles } from '../styles/Styles';

export function Status(props) {

  return (
    <Grid container spacing={props.spacing || 2} className={css([CommonStyles.statContainer, Styles.cardStyle])}>
      {props.items.map((item, index) => {
        return (
          <StatusTile
            key={'status-' + index}
            keyData={index}
            item={item}
            {...props} />
        )
      })}
    </Grid>
  )
}

const Styles = StyleSheet.create({
  outerGrid:{
    margin:0,
    marginBottom:10
  },
  StatusCardHolder:{
    display: 'flex',
    width: '100%'
  },
  cardStyle:{
    maxWidth:'unset',
    textAlign: 'left',
    marginBottom: 10,
    marginTop:5
  }
})


// WEBPACK FOOTER //
// ./src/components/Status.js